// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241957/js/" + chunkId + "." + {"44":"75207b15","225":"d3d02b5a","481":"d991e310","486":"bba3dea0","770":"2ff6cff7"}[chunkId] + ".0.8204188415656702.chunk.js";
};